import { h, Component } from "preact";

import SearchInput from "./SearchInput";
import Dropdown from "./Dropdown";
// import FilterSelector from "./FilterSelector";
import ProjectList from "./ProjectList";

// import settings from "./images/settings.svg";

/*const PROJECTS_CATEGORIES = [
  {
    fieldName: "status",
    label: "status",
    values: [{ label: "test", value: "test2" }]
  },
  {
    fieldName: "last_activity",
    label: "Last activity",
    values: []
  },
  {
    fieldName: "app_and_services",
    label: "App & services",
    values: []
  },
  {
    fieldName: "region",
    label: "region",
    values: []
  },
  {
    fieldName: "plan",
    label: "plan",
    values: []
  },
  {
    fieldName: "organization",
    label: "organization",
    values: []
  },
  {
    fieldName: "project",
    label: "project",
    values: []
  }
];*/

/*const getCategoriesValues = objects => {
  if (!objects || !objects.length) {
    return {};
  }

  const objectKeys = Object.keys(objects[0]);

  return objectKeys.reduce((acc, current) => {
    if (!acc[current]) {
      acc[current] = [];
    }

    acc[current] = [...new Set(objects.map(o => o[current]))].map(v => ({
      value: v,
      label: v
    }));

    return acc;
  }, {});
};*/

class Search extends Component {
  constructor(props) {
    super(props);

    this.setState({
      entity: "projects"
    });

    this.onFilterChange = this.onFilterChange.bind(this);
    this.onNameSeachChange = this.onNameSeachChange.bind(this);
    this.onNameSearch = this.onNameSearch.bind(this);
  }

  changeEntity({ value }) {
    this.setState({
      entity: value
    });
  }

  onFilterChange(filters) {
    this.setState({
      filters
    });

    this.props.onFilterChange(
      filters.filter(f => !!f && !!f.query).map(f => f.query)
    );
  }

  onNameSeachChange(e) {
    this.setState({ searchText: e.target.value });
  }

  onNameSearch(e) {
    e.stopPropagation();
    e.preventDefault();
    const filters = this.state.filters
      ? this.state.filters.filter(f => !!f && !!f.query).map(f => f.query)
      : [];
    const titleFilter = filters.find((v, k) => k === "project_title");
    const index = filters.indexOf(titleFilter);
    if (index === -1) {
      filters.push({
        project_title: {
          operator: "CONTAINS",
          value: this.state.searchText
        }
      });
    } else {
      filters[index] = {
        project_title: {
          operator: "CONTAINS",
          value: this.state.searchText
        }
      };
    }
    this.props.onFilterChange(filters);
  }

  render({ projects, accountUrl, isLoading }, { entity, searchText }) {
    let list = false;
    // let categories = [];
    const filter = /*(<div class="user-widget__mega_menu__search__filter_bar">
      <img src={settings} />
      <span>Filters</span>
      <FilterSelector
        categories={categories.map(c => ({
          value: c.fieldName,
          label: c.label
        }))}
        values={categories.reduce((acc, current) => {
          acc[current.fieldName] = current.values;
          return acc;
        }, {})}
        onChange={this.onFilterChange}
      />
    </div>)*/false;

    if (entity === "projects") {
      list = <ProjectList isLoading={isLoading} projects={projects} accountUrl={accountUrl} />;
      // categories = PROJECTS_CATEGORIES;
    }

    return (
      <div class="user-widget__mega_menu__search">
        <div class="user-widget__mega_menu__search__title_bar">
          <div class="user-widget__mega_menu__search__title_bar__left">
            <span>Search</span>
            <Dropdown
              onChange={this.changeEntity}
              defaultValue="projects"
              values={[{ value: "projects", label: "Projects" }]}
            />
          </div>
          <SearchInput
            onChange={this.onNameSeachChange}
            value={searchText}
            onClick={this.onNameSearch}
          />
        </div>
        {filter}
        {list}
      </div>
    );
  }
}

export default Search;



// WEBPACK FOOTER //
// ./src/Search.js